const majorStats = [
  {
    "major": "Chemical Engineering",
    "stem": 0.95,
    "practical": 0.85,
    "team": 0.75,
    "analytical": 0.90,
    "applied": 0.75
  },
  {
    "major": "Aerospace Engineering",
    "stem": 0.95,
    "practical": 0.85,
    "team": 0.75,
    "analytical": 0.90,
    "applied": 0.75
  },
  {
    "major": "Architecture",
    "stem": 0.70,
    "practical": 0.90,
    "team": 0.80,
    "analytical": 0.70,
    "applied": 0.90
  },
  {
    "major": "Nursing",
    "stem": 0.75,
    "practical": 0.95,
    "team": 0.90,
    "analytical": 0.70,
    "applied": 0.90
  },
  {
    "major": "Education",
    "stem": 0.50,
    "practical": 0.85,
    "team": 0.80,
    "analytical": 0.60,
    "applied": 0.80
  },
  {
    "major": "English Literature",
    "stem": 0.10,
    "practical": 0.50,
    "team": 0.40,
    "analytical": 0.90,
    "applied": 0.40
  },
  {
    "major": "History",
    "stem": 0.10,
    "practical": 0.40,
    "team": 0.40,
    "analytical": 0.85,
    "applied": 0.30
  },
  {
    "major": "Philosophy",
    "stem": 0.10,
    "practical": 0.30,
    "team": 0.30,
    "analytical": 0.95,
    "applied": 0.20
  },
  {
    "major": "Sociology",
    "stem": 0.50,
    "practical": 0.60,
    "team": 0.70,
    "analytical": 0.80,
    "applied": 0.60
  },
  {
    "major": "Anthropology",
    "stem": 0.50,
    "practical": 0.60,
    "team": 0.70,
    "analytical": 0.80,
    "applied": 0.60
  },
  {
    "major": "Geology",
    "stem": 0.90,
    "practical": 0.75,
    "team": 0.65,
    "analytical": 0.85,
    "applied": 0.70
  },
  {
    "major": "Geography",
    "stem": 0.70,
    "practical": 0.70,
    "team": 0.70,
    "analytical": 0.75,
    "applied": 0.70
  },
  {
    "major": "Statistics",
    "stem": 1.0,
    "practical": 0.50,
    "team": 0.40,
    "analytical": 1.0,
    "applied": 0.60
  },
  {
    "major": "Accounting",
    "stem": 0.60,
    "practical": 0.90,
    "team": 0.70,
    "analytical": 0.85,
    "applied": 0.80
  },
  {
    "major": "Management Information Systems",
    "stem": 0.75,
    "practical": 0.85,
    "team": 0.80,
    "analytical": 0.80,
    "applied": 0.85
  },
  {
    "major": "Supply Chain Management",
    "stem": 0.60,
    "practical": 0.90,
    "team": 0.85,
    "analytical": 0.75,
    "applied": 0.85
  },
  {
    "major": "Human Resources",
    "stem": 0.30,
    "practical": 0.85,
    "team": 0.90,
    "analytical": 0.70,
    "applied": 0.80
  },
  {
    "major": "Graphic Design",
    "stem": 0.20,
    "practical": 0.90,
    "team": 0.70,
    "analytical": 0.60,
    "applied": 0.90
  },
  {
    "major": "Fine Arts",
    "stem": 0.10,
    "practical": 0.85,
    "team": 0.50,
    "analytical": 0.50,
    "applied": 0.80
  },
  {
    "major": "Music",
    "stem": 0.10,
    "practical": 0.80,
    "team": 0.60,
    "analytical": 0.60,
    "applied": 0.75
  },
  {
    "major": "Pre-Medical Studies",
    "stem": 0.90,
    "practical": 0.80,
    "team": 0.70,
    "analytical": 0.85,
    "applied": 0.75
  },
  {
    "major": "Pharmacy",
    "stem": 0.90,
    "practical": 0.85,
    "team": 0.75,
    "analytical": 0.85,
    "applied": 0.80
  },
  {
    "major": "Veterinary Science",
    "stem": 0.90,
    "practical": 0.85,
    "team": 0.75,
    "analytical": 0.80,
    "applied": 0.80
  },
  {
    "major": "Linguistics",
    "stem": 0.40,
    "practical": 0.50,
    "team": 0.50,
    "analytical": 0.85,
    "applied": 0.60
  },
  {
    "major": "Communications",
    "stem": 0.20,
    "practical": 0.80,
    "team": 0.85,
    "analytical": 0.60,
    "applied": 0.75
  },
  {
    "major": "Journalism",
    "stem": 0.20,
    "practical": 0.85,
    "team": 0.70,
    "analytical": 0.70,
    "applied": 0.80
  },
  {
    "major": "Public Health",
    "stem": 0.70,
    "practical": 0.80,
    "team": 0.80,
    "analytical": 0.75,
    "applied": 0.85
  },
  {
    "major": "Nutrition",
    "stem": 0.75,
    "practical": 0.80,
    "team": 0.70,
    "analytical": 0.70,
    "applied": 0.80
  },
  {
    "major": "Exercise Science",
    "stem": 0.70,
    "practical": 0.85,
    "team": 0.75,
    "analytical": 0.65,
    "applied": 0.85
  }
]
  
export default majorStats